import React from 'react';
import {connect} from 'react-redux';
import {Routes, Route, Navigate} from 'react-router-dom';
import {createTheme, ThemeProvider, StyledEngineProvider} from '@mui/material/styles';
import PropTypes from 'prop-types';

import Conf from './config/config.js';

import Login from './pages/Login/index.js';
import ChangePassword from './pages/Login/changePassword.js';
import ResetPassword from './pages/Login/resetPassword.js';
import NewPassword from './pages/Login/newPassword.js';
import Loading from './components/organisms/Loading/index.js';
import Dialog from './components/organisms/Dialog/index.js';
import Scroll from './components/organisms/Scroll/index.js';
import Help from './components/templates/Help/index.js';
import Modal from './components/organisms/Modal/index.js';

import {GMN_PATH, GMN} from './common/commonConst.js';

import Menu from './pages/Menu/index.js';

// TODO メニューはログインユーザによって変わる
// import UserSelect from './pages/UserSelect/index.js';
// import List from './pages/List/index.js'; // 一覧

// お客さま情報照会
import CustomerInformationList from './pages/CustomerInformation/List/index.js';
// お客さま情報詳細
import CustomerInformationInfo from './pages/CustomerInformation/Info/index.js';
// 調査年度・委託エリア管理
import SurveyYearCompanyList from './pages/SCI/SCI1001/index.js';
// 調査年度・委託エリア登録
import SurveyYearCompanyInfo from './pages/SCI/SCI1002/index.js';
// 区画選択
// import ParcelSelection from './pages/InvestigationYearCompany/Select/index.js';
// 調査業種管理
import SurveyIndustryList from './pages/SCA/SCA1001/index.js';
// 調査業種登録
import SurveyIndustryInfo from './pages/SCA/SCA1002/index.js';
// 翌年度再調査管理
import SurveyReasonList from './pages/SCB/SCB1001/index.js';
// 翌年度再調査理由登録
import SurveyReasonInfo from './pages/SCB/SCB1002/index.js';
// 毎年調査お客さま全使撤リスト一覧
import ZensitetuList from './pages/Zensitetu/List/index.js';
// 毎年調査お客さま全使撤リスト
import ZensitetuInfo from './pages/Zensitetu/Info/index.js';
// 毎年調査お客さま全使撤リスト(調査機関用)
import ZensitetuItakuList from './pages/ZensitetuItaku/List/index.js';
// 調査口数一覧
import SurveyPopulationList from './pages/InvestigationPopulation/List/index.js';
// 調査・点検箇所追加交付
import TstkKasyoManageList from './pages/TstkKasyoManage/List/index.js';
// 調査・点検箇所追加申請
import TstkKasyoManageInfo from './pages/TstkKasyoManage/Info/index.js';
// 定期調査シート集計表出力
import InvestigationKukakuList from './pages/InvestigationKukaku/List/index.js';
// 年度計画登録
import AnnualSurveyPlanList from './pages/AnnualSurveyPlan/List/index.js';
// 年度計画登録(担当者)
import AnnualSurveyPlanInfo from './pages/AnnualSurveyPlan/Info/index.js';
// 承認申請一覧
import ApplicationApprovalList from './pages/SCZ/SCZ1005/index.js';
// ログ検索
import LogSearchList from './pages/SCZ/SCZ1007/index.js';
// ユーザ一覧
import UserMasterList from './pages/SCZ/SCZ1003/index.js';
// ユーザ詳細
import UserMasterInfo from './pages/SCZ/SCZ1004/index.js';
// ファイル管理
import FileMngList from './pages/FileMng/List/index.js';
// システム設定
import SystemSetting from './pages/SCZ/SCZ1010/index.js';
// 目標調査件数設定
import GoalInvestSettingList from './pages/GoalInvestSetting/List/index.js';
// 委託エリア設定
import GoalInvestSettingMesh from './pages/GoalInvestSetting/Mesh/index.js';
// 調査・点検結果報告
import TstkResultReportList from './pages/TstkResultReport/List/index.js';
// 調査・点検箇所一覧
import TstkKasyoList from './pages/TstkKasyo/List/index.js';
// 調査・点検結果確認
import TstkResultConfirmList from './pages/TstkResultConfirm/List/index.js';
// 調査・点検機関設定
import ItakuSettingList from './pages/ItakuSetting/List/index.js';
// 調査・点検口数(予定)一覧
import ItakuTsTkGutiSuList from './pages/ItakuTsTkGutiSu/List/index.js';
// 調査・点検実績確認
import TsTkActualConfirmList from './pages/TsTkActualConfirm/List/index.js';
// 調査・点検行程照会
import TstkKoTeiList from './pages/TstkKoTei/List/index.js';
// 調査・点検進捗状況照会(月別・工程別)
import TstkProgressMonthKoteiList from './pages/TstkProgressMonthKotei/List/index.js';
// 調査・点検進捗状況照会(ブロック別)
import TstkProgressBlockList from './pages/TstkProgressBlock/List/index.js';
// 調査・点検結果報告
import TstkProgressBlockReportList from './pages/TstkProgressBlock/ListReport/index.js';
// 定期調査実施状況
import TsTkImplementStatusList from './pages/TsTkImplementStatus/List/index.js';
// 調査・点検対象集計
import ItakuTsTkGutiSuSkList from './pages/ItakuTsTkGutiSu/ListSk/index.js';
// お客さま個別管理
import CustomerIndividualManageList from './pages/CustomerIndividualManage/List/index.js';
// お客さま個別登録
import CustomerIndividualManageInfo from './pages/CustomerIndividualManage/Info/index.js';
// 屋内線定期調査集計
import TkInvestigationTotalList from './pages/TkInvestigationTotal/List/index.js';

if (!Conf.consolelog) {
  console.log = function() {};
  console.info = function() {};
  console.dir = function() {};
  console.warn = function() {};
  console.error = function() {};
}

const themeDefault = createTheme({
  palette: {
    primary: {
      light: '#4791db', // 4791db DB9147
      main: '#4F89C6', // 1976d2 d27619
      dark: '#115293', // 115293 935211
      contrastText: '#fafafa',
    },
    secondary: {
      light: '#ffb6c1', // ffb6c1
      main: '#ff0000', // ff0000
      dark: '#8b0000', // 8b0000
      contrastText: '#fafafa',
    },
    typography: {
      useNextVariants: true,
    },
  },
});

const themes = {
  default: themeDefault,
};

const items = [
  {
    key: GMN.CUSTOMER_INFO_LIST.id,
    path: GMN_PATH.CUSTOMER_INFO_LIST,
    element: (
      <CustomerInformationList
        title={GMN.CUSTOMER_INFO_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.CUSTOMER_INFO_INFO.id,
    path: GMN_PATH.CUSTOMER_INFO_INFO,
    element: (
      <CustomerInformationInfo
        title={GMN.CUSTOMER_INFO_INFO.title}
        isEditPage={true}
      />
    ),
  },
  {
    key: GMN.SURVEY_YEAR_COMPANY_LIST.id,
    path: GMN_PATH.SURVEY_YEAR_COMPANY_LIST,
    element: (
      <SurveyYearCompanyList
        title={GMN.SURVEY_YEAR_COMPANY_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.SURVEY_YEAR_COMPANY_INFO.id,
    path: GMN_PATH.SURVEY_YEAR_COMPANY_INFO,
    element: (
      <SurveyYearCompanyInfo
        title={GMN.SURVEY_YEAR_COMPANY_INFO.title}
        isEditPage={true}
      />
    ),
  },
  {
    key: GMN.SURVEY_INDUSTRY_LIST.id,
    path: GMN_PATH.SURVEY_INDUSTRY_LIST,
    element: (
      <SurveyIndustryList
        title={GMN.SURVEY_INDUSTRY_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.SURVEY_INDUSTRY_INFO.id,
    path: GMN_PATH.SURVEY_INDUSTRY_INFO,
    element: (
      <SurveyIndustryInfo
        title={GMN.SURVEY_INDUSTRY_INFO.title}
        isEditPage={true}
      />
    ),
  },
  {
    key: GMN.SURVEY_REASON_LIST.id,
    path: GMN_PATH.SURVEY_REASON_LIST,
    element: (
      <SurveyReasonList
        title={GMN.SURVEY_REASON_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.SURVEY_REASON_INFO.id,
    path: GMN_PATH.SURVEY_REASON_INFO,
    element: (
      <SurveyReasonInfo
        title={GMN.SURVEY_REASON_INFO.title}
        isEditPage={true}
      />
    ),
  },
  {
    key: GMN.ZENSITETU_LIST.id,
    path: GMN_PATH.ZENSITETU_LIST,
    element: (
      <ZensitetuList
        title={GMN.ZENSITETU_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.ZENSITETU_INFO.id,
    path: GMN_PATH.ZENSITETU_INFO,
    element: (
      <ZensitetuInfo
        title={GMN.ZENSITETU_INFO.title}
        isEditPage={true}
      />
    ),
  },
  {
    key: GMN.ZENSITETU_ITAKU_LIST.id,
    path: GMN_PATH.ZENSITETU_ITAKU_LIST,
    element: (
      <ZensitetuItakuList
        title={GMN.ZENSITETU_ITAKU_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.INVESTIGATION_KUKAKU_LIST.id,
    path: GMN_PATH.INVESTIGATION_KUKAKU_LIST,
    element: (
      <InvestigationKukakuList
        title={GMN.INVESTIGATION_KUKAKU_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.SURVEY_POPULATION_LIST.id,
    path: GMN_PATH.SURVEY_POPULATION_LIST,
    element: (
      <SurveyPopulationList
        title={GMN.SURVEY_POPULATION_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.TSTK_KASYO_MANAGE_LIST.id,
    path: GMN_PATH.TSTK_KASYO_MANAGE_LIST,
    element: (
      <TstkKasyoManageList
        title={GMN.TSTK_KASYO_MANAGE_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.TSTK_KASYO_MANAGE_INFO.id,
    path: GMN_PATH.TSTK_KASYO_MANAGE_INFO,
    element: (
      <TstkKasyoManageInfo
        title={GMN.TSTK_KASYO_MANAGE_INFO.title}
        isEditPage={true}
      />
    ),
  },
  {
    key: GMN.ANNUAL_SURVERY_PLAN_LIST.id,
    path: GMN_PATH.ANNUAL_SURVERY_PLAN_LIST,
    element: (
      <AnnualSurveyPlanList
        title={GMN.ANNUAL_SURVERY_PLAN_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.ANNUAL_SURVERY_PLAN_INFO.id,
    path: GMN_PATH.ANNUAL_SURVERY_PLAN_INFO,
    element: (
      <AnnualSurveyPlanInfo
        title={GMN.ANNUAL_SURVERY_PLAN_INFO.title}
        isEditPage={true}
      />
    ),
  },
  {
    key: GMN.LOGSEARCH_LIST.id,
    path: GMN_PATH.LOGSEARCH_LIST,
    element: (
      <LogSearchList
        title={GMN.LOGSEARCH_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.USER_MASTER_LIST.id,
    path: GMN_PATH.USER_MASTER_LIST,
    element: (
      <UserMasterList
        title={GMN.USER_MASTER_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.USER_MASTER_INFO.id,
    path: GMN_PATH.USER_MASTER_INFO,
    element: (
      <UserMasterInfo
        title={GMN.USER_MASTER_INFO.title}
        isEditPage={true}
      />
    ),
  },
  {
    key: GMN.APPLICATION_APPROVAL_LIST.id,
    path: GMN_PATH.APPLICATION_APPROVAL_LIST,
    element: (
      <ApplicationApprovalList
        title={GMN.APPLICATION_APPROVAL_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.FILE_MNG_LIST.id,
    path: GMN_PATH.FILE_MNG_LIST,
    element: (
      <FileMngList
        title={GMN.FILE_MNG_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.SYSTEM_SETTING.id,
    path: GMN_PATH.SYSTEM_SETTING,
    element: (
      <SystemSetting
        title={GMN.SYSTEM_SETTING.title}
        isEditPage={true}
      />
    ),
  },
  {
    key: GMN.GOAL_INVEST_SETTING_LIST.id,
    path: GMN_PATH.GOAL_INVEST_SETTING_LIST,
    element: (
      <GoalInvestSettingList
        title={GMN.GOAL_INVEST_SETTING_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.GOAL_INVEST_SETTING_MESH.id,
    path: GMN_PATH.GOAL_INVEST_SETTING_MESH,
    element: (
      <GoalInvestSettingMesh
        title={GMN.GOAL_INVEST_SETTING_MESH.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.TSTK_RESULT_REPORT_LIST.id,
    path: GMN_PATH.TSTK_RESULT_REPORT_LIST,
    element: (
      <TstkResultReportList
        title={GMN.TSTK_RESULT_REPORT_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.TSTK_KASYO_LIST.id,
    path: GMN_PATH.TSTK_KASYO_LIST,
    element: (
      <TstkKasyoList
        title={GMN.TSTK_KASYO_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.TSTK_RESULT_CONFIRM_LIST.id,
    path: GMN_PATH.TSTK_RESULT_CONFIRM_LIST,
    element: (
      <TstkResultConfirmList
        title={GMN.TSTK_RESULT_CONFIRM_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.ITAKU_SETTING_LIST.id,
    path: GMN_PATH.ITAKU_SETTING_LIST,
    element: (
      <ItakuSettingList
        title={GMN.ITAKU_SETTING_LIST.title}
        isEditPage={true}
      />
    ),
  },
  {
    key: GMN.ITAKU_TSTK_GUTISU_LIST.id,
    path: GMN_PATH.ITAKU_TSTK_GUTISU_LIST,
    element: (
      <ItakuTsTkGutiSuList
        title={GMN.ITAKU_TSTK_GUTISU_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.TSTK_ACTUAL_CONFIRM_LIST.id,
    path: GMN_PATH.TSTK_ACTUAL_CONFIRM_LIST,
    element: (
      <TsTkActualConfirmList
        title={GMN.TSTK_ACTUAL_CONFIRM_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.TSTK_KOTEI_LIST.id,
    path: GMN_PATH.TSTK_KOTEI_LIST,
    element: (
      <TstkKoTeiList
        title={GMN.TSTK_KOTEI_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.TSTK_PROGRESS_MONTH_KOTEI_LIST.id,
    path: GMN_PATH.TSTK_PROGRESS_MONTH_KOTEI_LIST,
    element: (
      <TstkProgressMonthKoteiList
        title={GMN.TSTK_PROGRESS_MONTH_KOTEI_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.TSTK_PROGRESS_BLOCK_LIST.id,
    path: GMN_PATH.TSTK_PROGRESS_BLOCK_LIST,
    element: (
      <TstkProgressBlockList
        title={GMN.TSTK_PROGRESS_BLOCK_LIST.title}
        isEditPage={false}
      />
    ),
  },
  // 調査・点検対象集計
  {
    key: GMN.TSTK_PROGRESS_BLOCK_REPORT_LIST.id,
    path: GMN_PATH.TSTK_PROGRESS_BLOCK_REPORT_LIST,
    element: (
      <TstkProgressBlockReportList
        title={GMN.TSTK_PROGRESS_BLOCK_REPORT_LIST.title}
        isEditPage={false}
      />
    ),
  },
  {
    key: GMN.TSTK_IMPLEMENT_STATUS_LIST.id,
    path: GMN_PATH.TSTK_IMPLEMENT_STATUS_LIST,
    element: (
      <TsTkImplementStatusList
        title={GMN.TSTK_IMPLEMENT_STATUS_LIST.title}
        isEditPage={false}
      />
    ),
  },
  // 調査・点検対象集計
  {
    key: GMN.ITAKU_TSTK_GUTISU_SK_LIST.id,
    path: GMN_PATH.ITAKU_TSTK_GUTISU_SK_LIST,
    element: (
      <ItakuTsTkGutiSuSkList
        title={GMN.ITAKU_TSTK_GUTISU_SK_LIST.title}
        isEditPage={false}
      />
    ),
  },
  // お客さま個別管理
  {
    key: GMN.CUSTOMER_INDIVIDUAL_MANAGE_LIST.id,
    path: GMN_PATH.CUSTOMER_INDIVIDUAL_MANAGE_LIST,
    element: (
      <CustomerIndividualManageList
        title={GMN.CUSTOMER_INDIVIDUAL_MANAGE_LIST.title}
        isEditPage={false}
      />
    ),
  },
  // お客さま個別登録
  {
    key: GMN.CUSTOMER_INDIVIDUAL_MANAGE_INFO.id,
    path: GMN_PATH.CUSTOMER_INDIVIDUAL_MANAGE_INFO,
    element: (
      <CustomerIndividualManageInfo
        title={GMN.CUSTOMER_INDIVIDUAL_MANAGE_INFO.title}
        isEditPage={true}
      />
    ),
  },
  // 屋内線定期調査集計
  {
    key: GMN.TK_INVESTIGATION_TOTAL_LIST.id,
    path: GMN_PATH.TK_INVESTIGATION_TOTAL_LIST,
    element: (
      <TkInvestigationTotalList
        title={GMN.TK_INVESTIGATION_TOTAL_LIST.title}
        isEditPage={false}
      />
    ),
  },

];

const routes = ({theme}) => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={themes[theme]}>
      <Loading />
      <Scroll />
      <Modal content={<Help />} />
      <Dialog />
      <Routes>
        <Route
          path="/"
          element={<Login/>}
        />
        <Route
          path="/login"
          element={<Login/>}
        />
        <Route
          path="/resetPassword"
          element={<ResetPassword/>}
        />
        <Route
          path="/newPassword"
          element={<NewPassword/>}
        />
        <Route
          path="/changePassword"
          element={
            <RequireAuth>
              <ChangePassword title="パスワード変更"/>
            </RequireAuth>
          }
        />
        <Route
          path="/menu"
          element={
            <RequireAuth>
              <Menu title="メニュー"/>
            </RequireAuth>
          }
        />
        {
          items.map((item) => {
            return (<Route
              key={item.key}
              path={item.path}
              element={
                <RequireAuth>
                  {item.element}
                </RequireAuth>
              }
            />);
          })
        }
        <Route path="*" element={<Login/>}/>
      </Routes>
    </ThemeProvider>
  </StyledEngineProvider>

);

const requireAuth = ({isLoggedIn, children}) => {
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

requireAuth.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  children: PropTypes.object,
};

const mapStateToProps = (state) => ({
  isLoggedIn: state.auth.isLoggedIn,
});

const RequireAuth = connect(mapStateToProps)(requireAuth);

// ///////////////////////////////////////////////////////////

const mapStateToPropsForMui = (state) => ({
  theme: state.style.theme,
});

const RoutesComponent = connect(mapStateToPropsForMui)(routes);

export default RoutesComponent;
